// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDescripton_description__MiQTC {
  padding: 16px;
}
.OrderDescripton_description--is-loading__cS6S8 {
  height: 200px;
  border-radius: 8px;
  margin-top: 12px;
  margin-left: 12px;
  margin-right: 12px;
}
@media (min-width: 1200px) {
  .OrderDescripton_description__MiQTC {
    padding: 12px;
  }
}

.OrderDescripton_list__irCaZ {
  list-style-type: none;
  padding: 0;
}

.OrderDescripton_row__Un5De {
  position: relative;
  margin-bottom: 8px;
  border-bottom: 1px solid #F3F2F2;
  padding-bottom: 8px;
}
.OrderDescripton_row__Un5De:last-child {
  margin-bottom: 0;
}
@media (min-width: 1200px) {
  .OrderDescripton_row__Un5De {
    border-bottom: none;
    padding-bottom: 0;
  }
}

.OrderDescripton_rowTitle__v9Rvq {
  font-size: var(--fz-sm);
  font-weight: 400;
  line-height: 114%;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderDescripton_rowTitle__v9Rvq {
    font-size: var(--fz-xs);
    line-height: 12px;
    font-weight: 500;
  }
}

.OrderDescripton_rowTxt__ZxLuB {
  font-size: var(--fz-lg);
  font-weight: 400;
  line-height: 144%;
  white-space: pre-line;
}
@media (min-width: 1200px) {
  .OrderDescripton_rowTxt__ZxLuB {
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
  }
}

.OrderDescripton_orderer__ABYv9 {
  margin-bottom: 8px;
}
.OrderDescripton_orderer__ABYv9 .OrderDescripton_rowTitle__v9Rvq {
  margin-bottom: 5px;
}
.OrderDescripton_orderer__wrap__mozjy {
  display: flex;
  align-items: center;
  grid-gap: 5px;
}
@media (min-width: 1200px) {
  .OrderDescripton_orderer__wrap__mozjy {
    grid-gap: 6px;
  }
}
.OrderDescripton_orderer__name__jGZ8F {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 144%;
}
@media (min-width: 1200px) {
  .OrderDescripton_orderer__name__jGZ8F {
    font-size: 12px;
    line-height: 113%;
  }
}

.OrderDescripton_assignee__P6A9O {
  margin-bottom: 8px;
}
.OrderDescripton_assignee__P6A9O .rating-star-label {
  width: 25px;
}
.OrderDescripton_assignee__wrap__nw0Nx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.OrderDescripton_assignee__info__5Xo2n {
  max-width: calc(100% - 46px);
}
.OrderDescripton_assignee__avatar__4I6qA {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
.OrderDescripton_assignee__name__XVkXR {
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
  color: #54575C;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.OrderDescripton_assignee__names__C4BGC {
  font-size: 12px;
  line-height: normal;
  margin-top: 4px;
}
.OrderDescripton_assignee__listTitle__LgrJD {
  font-size: 10px;
  font-weight: 500;
  color: #54575C;
  margin-bottom: 4px;
}

.OrderDescripton_information-row__mo2n6 {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.OrderDescripton_information-row__mo2n6 p {
  font-size: var(--fz-sm);
  font-weight: 400;
  line-height: 114%;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__mo2n6 p {
    font-size: var(--fz-xs);
    line-height: 12px;
    font-weight: 500;
  }
}
.OrderDescripton_information-row__mo2n6 h5 {
  margin-bottom: 4px;
  font-size: var(--fz-lg);
  font-weight: 400;
  line-height: 144%;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__mo2n6 h5 {
    font-size: var(--fz-md);
    font-weight: 600;
    line-height: 114%;
  }
}
.OrderDescripton_information-row__content__LhX7d {
  display: flex;
  flex-direction: column;
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo * {
  font-size: var(--fz-md);
  line-height: var(--lh-sm);
  font-weight: initial;
  margin-bottom: 8px;
}
@media (min-width: 1200px) {
  .OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo * {
    font-size: var(--fz-sm);
  }
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo img {
  max-width: 100%;
}
.OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo ul, .OrderDescripton_information-row__content__LhX7d .OrderDescripton_info-text__d-0Jo ol {
  padding-inline-start: 30px;
}

.OrderDescripton_photo-block__\\+\\+gYp {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 8px;
}
@media (min-width: 640px) {
  .OrderDescripton_photo-block__\\+\\+gYp {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 1200px) {
  .OrderDescripton_photo-block__\\+\\+gYp {
    grid-template-columns: 1fr 1fr;
  }
}
.OrderDescripton_photo-block__preview__FfvOO {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.OrderDescripton_photo-block__preview__FfvOO > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
@media (min-width: 640px) {
  .OrderDescripton_photo-block__preview__FfvOO {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .OrderDescripton_photo-block__preview__FfvOO {
    height: 80px;
  }
}

.OrderDescripton_file-block__rfXz5 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__Hd64- {
  display: flex;
  gap: 10px;
  width: max-content;
}
.OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__text__vBJw3 {
  font-size: var(--fz-lg);
}
@media (min-width: 1200px) {
  .OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__Hd64- {
    width: auto;
  }
  .OrderDescripton_file-block__rfXz5 .OrderDescripton_file-row__text__vBJw3 {
    font-size: var(--fz-sm);
  }
}

.OrderDescripton_order-descr-accord__b4kiF {
  padding-right: 4px;
}
.OrderDescripton_coordinators-container__teiwF {
  margin-top: 16px;
}
.OrderDescripton_coordinators-container__teiwF h4 {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OrderDescripton_coordination-accordion__IQI1s {
  margin-top: 16px;
}

.OrderDescripton_order-descr-container__94QLC {
  position: relative;
}
.OrderDescripton_order-descr-container__94QLC .OrderDescripton_canceled__Pi6IP {
  position: absolute;
  top: -20px;
  right: 0;
}

.OrderDescripton_approval-title__6HLqY {
  display: inline-flex;
  align-items: center;
  grid-gap: 3px;
  font-size: 12px;
  line-height: normal;
}
.OrderDescripton_approval-title--res__wHPb3 {
  color: var(--accent-color);
}
.OrderDescripton_approval-title--rej__cxhOd {
  color: #F54E4C;
}
.OrderDescripton_approval-title--load__44TBF {
  color: #177FD2;
}

.OrderDescripton_labelInfo__H4loy {
  position: absolute;
  right: 0;
  top: 0;
}
@media (min-width: 1200px) {
  .OrderDescripton_labelInfo__H4loy {
    display: none;
  }
}
@media (min-width: 1200px) {
  .OrderDescripton_labelInfo__H4loy.OrderDescripton_statusInfo__0Kk0Y {
    font-size: 10px;
    padding: 6px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderDescription/OrderDescripton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAEE;EAXF;IAYI,aAAA;EACF;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EAVF;IAWI,mBAAA;IACA,iBAAA;EACF;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EANF;IAOI,uBAAA;IACA,iBAAA;IACA,gBAAA;EAEF;AACF;;AACA;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAEF;AAAE;EANF;IAOI,uBAAA;IACA,yBAAA;EAGF;AACF;;AAAA;EACE,kBAAA;AAGF;AADE;EACE,kBAAA;AAGJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAEJ;AAAI;EALF;IAMI,aAAA;EAGJ;AACF;AAAE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;AAAI;EATF;IAUI,eAAA;IACA,iBAAA;EAGJ;AACF;;AACA;EACE,kBAAA;AAEF;AACI;EACE,WAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AADJ;AAIE;EACE,4BAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAHJ;AAME;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AANJ;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAPF;AASE;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAPJ;AASI;EANF;IAOI,uBAAA;IACA,iBAAA;IACA,gBAAA;EANJ;AACF;AASE;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AASI;EANF;IAOI,uBAAA;IACA,gBAAA;IACA,iBAAA;EANJ;AACF;AASE;EACE,aAAA;EACA,sBAAA;AAPJ;AAUM;EACE,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AARR;AAUQ;EANF;IAOI,uBAAA;EAPR;AACF;AAUM;EACE,eAAA;AARR;AAWM;EACE,0BAAA;AATR;;AAeA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AAZF;AAcE;EANF;IAOI,qCAAA;EAXF;AACF;AAaE;EAVF;IAWI,8BAAA;EAVF;AACF;AAYE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAeI;EADF;IAEI,aAAA;EAZJ;AACF;AAcI;EALF;IAMI,YAAA;EAXJ;AACF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZF;AAcE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAZJ;AAcI;EACE,uBAAA;AAZN;AAeI;EATF;IAUI,WAAA;EAZJ;EAcI;IACE,uBAAA;EAZN;AACF;;AAiBA;EACE,kBAAA;AAdF;AAuBA;EACE,gBAAA;AArBF;AAuBE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AArBJ;;AAyBA;EACE,gBAAA;AAtBF;;AAyBA;EACE,kBAAA;AAtBF;AAwBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAtBJ;;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAvBF;AAyBE;EACE,0BAAA;AAvBJ;AA0BE;EACE,cAAA;AAxBJ;AA2BE;EACE,cAAA;AAzBJ;;AA6BA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AA1BF;AA4BE;EALF;IAMI,aAAA;EAzBF;AACF;AA4BI;EADF;IAEI,eAAA;IACA,iBAAA;EAzBJ;AACF","sourcesContent":[".description {\r\n  padding: 16px;\r\n\r\n  &--is-loading {\r\n    height: 200px;\r\n    border-radius: 8px;\r\n    margin-top: 12px;\r\n    margin-left: 12px;\r\n    margin-right: 12px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.row {\r\n  position: relative;\r\n  margin-bottom: 8px;\r\n  border-bottom: 1px solid #F3F2F2;\r\n  padding-bottom: 8px;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n  }\r\n}\r\n\r\n.rowTitle {\r\n  font-size: var(--fz-sm);\r\n  font-weight: 400;\r\n  line-height: 114%;\r\n  color: #54575C;\r\n\r\n  @media(min-width: 1200px) {\r\n    font-size: var(--fz-xs);\r\n    line-height: 12px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.rowTxt {\r\n  font-size: var(--fz-lg);\r\n  font-weight: 400;\r\n  line-height: 144%;\r\n  white-space: pre-line;\r\n\r\n  @media(min-width: 1200px) {\r\n    font-size: var(--fz-sm);\r\n    line-height: var(--lh-sm);\r\n  }\r\n}\r\n\r\n.orderer {\r\n  margin-bottom: 8px;\r\n\r\n  .rowTitle {\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  &__wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    grid-gap: 5px;\r\n\r\n    @media (min-width: 1200px) {\r\n      grid-gap: 6px;\r\n    }\r\n  }\r\n\r\n  &__name {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 1;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 16px;\r\n    line-height: 144%;\r\n\r\n    @media (min-width: 1200px) {\r\n      font-size: 12px;\r\n      line-height: 113%;\r\n    }\r\n  }\r\n}\r\n\r\n.assignee {\r\n  margin-bottom: 8px;\r\n\r\n  :global {\r\n    .rating-star-label {\r\n      width: 25px;\r\n    }\r\n  }\r\n\r\n  &__wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n  }\r\n\r\n  &__info {\r\n    max-width: calc(100% - 46px);\r\n  }\r\n\r\n  &__avatar {\r\n    flex-shrink: 0;\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n  }\r\n\r\n  &__name {\r\n    font-size: var(--fz-sm);\r\n    line-height: var(--lh-sm);\r\n    color: #54575C;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 1;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__names {\r\n    font-size: 12px;\r\n    line-height: normal;\r\n    margin-top: 4px;\r\n  }\r\n\r\n  &__listTitle {\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    color: #54575C;\r\n    margin-bottom: 4px;\r\n  }\r\n}\r\n\r\n.information-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 8px;\r\n\r\n  p {\r\n    font-size: var(--fz-sm);\r\n    font-weight: 400;\r\n    line-height: 114%;\r\n    color: #54575C;\r\n  \r\n    @media(min-width: 1200px) {\r\n      font-size: var(--fz-xs);\r\n      line-height: 12px;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  h5 {\r\n    margin-bottom: 4px;\r\n    font-size: var(--fz-lg);\r\n    font-weight: 400;\r\n    line-height: 144%;\r\n    \r\n    @media (min-width: 1200px) {\r\n      font-size: var(--fz-md);\r\n      font-weight: 600;\r\n      line-height: 114%;\r\n    }\r\n  }\r\n\r\n  &__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .info-text {\r\n      * {\r\n        font-size: var(--fz-md);\r\n        line-height: var(--lh-sm);\r\n        font-weight: initial;\r\n        margin-bottom: 8px;\r\n\r\n        @media (min-width: 1200px) {\r\n          font-size: var(--fz-sm);\r\n        }\r\n      }\r\n\r\n      img {\r\n        max-width: 100%;\r\n      }\r\n\r\n      ul, ol {\r\n        padding-inline-start: 30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.photo-block {\r\n  display: grid;\r\n  grid-gap: 8px;\r\n  grid-template-columns: 1fr 1fr;\r\n  margin-bottom: 8px;\r\n\r\n  @media (min-width: 640px) {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  &__preview {\r\n    height: 105px;\r\n    border-radius: 8px;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n\r\n    &>img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: contain;\r\n      object-position: center;\r\n    }\r\n  }\r\n\r\n  &__preview {\r\n    @media (min-width: 640px) {\r\n      height: 140px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 80px;\r\n    }\r\n  }\r\n}\r\n\r\n.file-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n\r\n  .file-row {\r\n    display: flex;\r\n    gap: 10px;\r\n    width: max-content;\r\n\r\n    &__text {\r\n      font-size: var(--fz-lg);\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      width: auto;\r\n\r\n      &__text {\r\n        font-size: var(--fz-sm);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.order-descr-accord {\r\n  padding-right: 4px;\r\n\r\n  :global {\r\n    .accordion-main {\r\n      // max-height: 500px;\r\n    }\r\n  }\r\n}\r\n\r\n.coordinators-container {\r\n  margin-top: 16px;\r\n\r\n  h4 {\r\n    margin-bottom: 8px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.coordination-accordion {\r\n  margin-top: 16px;\r\n}\r\n\r\n.order-descr-container {\r\n  position: relative;\r\n\r\n  .canceled {\r\n    position: absolute;\r\n    top: -20px;\r\n    right: 0;\r\n  }\r\n}\r\n\r\n.approval-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  grid-gap: 3px;\r\n  font-size: 12px;\r\n  line-height: normal;\r\n\r\n  &--res {\r\n    color: var(--accent-color);\r\n  }\r\n\r\n  &--rej {\r\n    color: #F54E4C;\r\n  }\r\n\r\n  &--load {\r\n    color: #177FD2;\r\n  }\r\n}\r\n\r\n.labelInfo {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n\r\n  @media (min-width: 1200px) {\r\n    display: none;\r\n  }\r\n\r\n  &.statusInfo {\r\n    @media (min-width: 1200px) {\r\n      font-size: 10px;\r\n      padding: 6px 10px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `OrderDescripton_description__MiQTC`,
	"description--is-loading": `OrderDescripton_description--is-loading__cS6S8`,
	"list": `OrderDescripton_list__irCaZ`,
	"row": `OrderDescripton_row__Un5De`,
	"rowTitle": `OrderDescripton_rowTitle__v9Rvq`,
	"rowTxt": `OrderDescripton_rowTxt__ZxLuB`,
	"orderer": `OrderDescripton_orderer__ABYv9`,
	"orderer__wrap": `OrderDescripton_orderer__wrap__mozjy`,
	"orderer__name": `OrderDescripton_orderer__name__jGZ8F`,
	"assignee": `OrderDescripton_assignee__P6A9O`,
	"assignee__wrap": `OrderDescripton_assignee__wrap__nw0Nx`,
	"assignee__info": `OrderDescripton_assignee__info__5Xo2n`,
	"assignee__avatar": `OrderDescripton_assignee__avatar__4I6qA`,
	"assignee__name": `OrderDescripton_assignee__name__XVkXR`,
	"assignee__names": `OrderDescripton_assignee__names__C4BGC`,
	"assignee__listTitle": `OrderDescripton_assignee__listTitle__LgrJD`,
	"information-row": `OrderDescripton_information-row__mo2n6`,
	"information-row__content": `OrderDescripton_information-row__content__LhX7d`,
	"info-text": `OrderDescripton_info-text__d-0Jo`,
	"photo-block": `OrderDescripton_photo-block__++gYp`,
	"photo-block__preview": `OrderDescripton_photo-block__preview__FfvOO`,
	"file-block": `OrderDescripton_file-block__rfXz5`,
	"file-row": `OrderDescripton_file-row__Hd64-`,
	"file-row__text": `OrderDescripton_file-row__text__vBJw3`,
	"order-descr-accord": `OrderDescripton_order-descr-accord__b4kiF`,
	"coordinators-container": `OrderDescripton_coordinators-container__teiwF`,
	"coordination-accordion": `OrderDescripton_coordination-accordion__IQI1s`,
	"order-descr-container": `OrderDescripton_order-descr-container__94QLC`,
	"canceled": `OrderDescripton_canceled__Pi6IP`,
	"approval-title": `OrderDescripton_approval-title__6HLqY`,
	"approval-title--res": `OrderDescripton_approval-title--res__wHPb3`,
	"approval-title--rej": `OrderDescripton_approval-title--rej__cxhOd`,
	"approval-title--load": `OrderDescripton_approval-title--load__44TBF`,
	"labelInfo": `OrderDescripton_labelInfo__H4loy`,
	"statusInfo": `OrderDescripton_statusInfo__0Kk0Y`
};
export default ___CSS_LOADER_EXPORT___;
